import { render, staticRenderFns } from "./ModelPayee.vue?vue&type=template&id=31bd8666&scoped=true"
import script from "./ModelPayee.vue?vue&type=script&lang=js"
export * from "./ModelPayee.vue?vue&type=script&lang=js"
import style0 from "./ModelPayee.vue?vue&type=style&index=0&id=31bd8666&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31bd8666",
  null
  
)

export default component.exports